import {put,takeLatest,call} from 'redux-saga/effects';
import * as extraService from "../../../../services/extraService.js";

import {
    GET_EXTRA,
    GET_EXTRA_SUCCESS,
    GET_EXTRA_ERROR
}
    from "../../../actions/menu/extras";

function* getExtraSaga(action) {
    try {
        const data=yield call(extraService.GetExtra,action.payload)
        yield put({
            type: GET_EXTRA_SUCCESS,
            payload: data
        });

    } catch(error) {
        yield put({
            type: GET_EXTRA_ERROR,error: error.data
        });
    }
}


export function* getExtraSagaWatcher() {
    yield takeLatest(GET_EXTRA,getExtraSaga);
}